import { apiClient } from './client.js';

export const learningApi = {
  enrollCourse: (courseId) => apiClient.post(`/learning/enroll/${courseId}`),
  getMyCourses: () => apiClient.get('/learning/my-courses'),
  getCourseProgress: (courseId) => apiClient.get(`/learning/courses/${courseId}/progress`),
  completeLesson: (lessonId) => apiClient.post(`/learning/lessons/${lessonId}/complete`),
};
